module.exports = __webpack_public_path__ + "static/img/home_icon2.8db71be9.png";